import { Controller } from "@hotwired/stimulus"

// Keeps a chat timeline pinned to the newest message: scrolls to the bottom on
// connect, and auto-follows appended messages while the reader is already near
// the bottom (a reader scrolled up into history is never yanked down).
export default class extends Controller {
  static NEAR_BOTTOM_PX = 120

  connect() {
    this.scrollToBottom()
    this.observer = new MutationObserver(() => {
      if (this.nearBottom) this.scrollToBottom()
    })
    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  get nearBottom() {
    const el = this.element
    return el.scrollHeight - el.scrollTop - el.clientHeight < this.constructor.NEAR_BOTTOM_PX
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
